// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 56,
  H_DESKTOP: 60,
  H_DESKTOP_OFFSET: 60 - 16,
};

export const NAV = {
  W_VERTICAL: 230,
  W_MINI: 88,
};

export const ADMIN_BANNER = {
  HEIGHT: 40,
};

/**
 * Padding horizontal du contenu principal (main.js).
 * Source unique — importer cette constante partout ou le padding doit etre
 * compense (ex. bandes full-bleed dans les settings).
 */
export const CONTENT_PADDING = {xs: 1.5, sm: 2, lg: 5};

/**
 * Marges negatives pour les sections pleine largeur (full-bleed).
 * Annule exactement le CONTENT_PADDING pour etendre un fond au bord du viewport.
 */
export const FULL_BLEED_MX = {xs: -1.5, sm: -2, lg: -5};

/**
 * Retraits du viewport imposes par le materiel (encoche, coins arrondis,
 * barre de gestes). L'app declare `viewport-fit=cover` : le contenu occupe
 * toute la dalle, c'est donc a nous de reserver ces zones.
 *
 * Les retraits horizontaux ne valent 0 qu'en portrait. En paysage l'encoche
 * passe sur le cote, d'ou la necessite de les appliquer aux conteneurs
 * ancres aux bords (header, bottom nav, contenu principal, barres flottantes).
 */
export const SAFE_AREA_X = {
  LEFT: 'env(safe-area-inset-left, 0px)',
  RIGHT: 'env(safe-area-inset-right, 0px)',
};

/**
 * Retrait du haut (barre d'etat iOS en PWA plein ecran). Vaut 0 partout
 * ailleurs : l'ajouter ne change rien sur PC. A lire par tout conteneur
 * ancre au bord haut en layout desktop (contenu principal, menus fixes) ;
 * le layout mobile l'applique deja via son header.
 */
export const SAFE_AREA_TOP = 'env(safe-area-inset-top, 0px)';
